import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import Decimal from 'decimal.js';
import { Controller, useFormContext } from 'react-hook-form';
import DiscountTextField from '~/components/DiscountTextField';
import { useLocaleKeys } from '~/i18n';
import { DiscountModel, DiscountType } from '~/models';
import { utils } from '~/utils';
import { connectControllerToDiscountTextField } from '~/utils/react-hook-form.utils';
export default function DiscountInput(param) {
    let { onChange = ()=>{}, testId } = param;
    const { control, watch, trigger, getValues } = useFormContext();
    const { t: discountTexts } = useLocaleKeys('billing.discount');
    const [pricing, price, minPrice, billingTrigger, oneTimeInStagesBilling, discountType, bundle] = watch([
        'pricing',
        'price',
        'minPrice',
        'trigger',
        'oneTimeInStagesBilling',
        'discount.type',
        'bundle'
    ]);
    const isBundle = Boolean(bundle && bundle.length > 0);
    useEffect(()=>{
        trigger('discount');
    }, [
        pricing,
        price,
        minPrice,
        billingTrigger,
        oneTimeInStagesBilling
    ]);
    return /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: "discount",
        rules: {
            validate: (param)=>{
                let { type, amount } = param;
                if (!amount || amount.trim() === '') {
                    return true;
                }
                const { pricing, price, minPrice, oneTimeInStagesBilling } = getValues();
                if (+amount < 0) {
                    return discountTexts.validation.mustBeNonNegative();
                }
                const discountAmount = +amount;
                const hasDiscountAmount = !isNaN(discountAmount) && discountAmount > 0;
                if (hasDiscountAmount) {
                    const errorMsg = discountTexts.validation.cannotExceedPrice();
                    if (price && utils.applyDiscount(new Decimal(+price), DiscountModel.make(type, discountAmount)).lessThan(0)) return errorMsg;
                    if (pricing === 'range' && minPrice && utils.applyDiscount(new Decimal(+minPrice), DiscountModel.make(type, discountAmount)).lessThan(0)) return errorMsg;
                }
                if (!!oneTimeInStagesBilling && type !== DiscountType.Percent) return discountTexts.validation.mustBePercentageForStages();
                if (isBundle && type !== DiscountType.Percent) return discountTexts.validation.mustBePercentageForBundle();
            }
        },
        render: (p)=>{
            const connectedProps = connectControllerToDiscountTextField(p);
            return /*#__PURE__*/ _jsx(DiscountTextField, _object_spread_props(_object_spread({
                alwaysShrinkLabel: true,
                label: discountType === DiscountType.Percent ? discountTexts.label() : discountTexts.unitLabel(),
                testId: testId
            }, connectedProps), {
                onChange: (value)=>{
                    onChange(value);
                    connectedProps.onChange(value);
                },
                isBillInStages: !!oneTimeInStagesBilling,
                isBundle: isBundle
            }));
        }
    });
}
